











import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class PageTabNavigation extends Vue {
  @Prop({ type: Array, default: [] }) routes!: string[];
}
